import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-1"}]]

const IconCircleLetterC = createReactComponent('outline', 'circle-letter-c', 'CircleLetterC', __iconNode);

export default IconCircleLetterC;